import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResponseSAS } from '../../Interfaces/ResponseSAS';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CotacaoService {

  constructor(private http: HttpClient) { }

  FazerCotacao(
    CodigoPais: String,
    MotivoViagem: String,
    IncluiEuropa: Number,
    DataIda: String,
    DataVolta: String,
    QtdePassSenior: Number = 0,
    QtdePassNaoSenior: Number = 0,
    CupomDesconto: String,
    DiasMultiviagem: Number,
    CodigoTipoProduto: String,
    SessionID: string
  ) {
    return this.http.post<ResponseSAS>(
      environment.urlSAS,
      {
        "userToken": "TOKEN",
        "screenIdentification": environment[localStorage.ambiente].fazerCotacao,
        "Parameters": [
          { "parametername": "CountryCode", "parametervalue": CodigoPais },
          { "parametername": "PurposeOfTripCode", "parametervalue": MotivoViagem },
          { "parametername": "IncludesEurope", "parametervalue": IncluiEuropa },
          { "parametername": "DataInicioViagem", "parametervalue": DataIda },
          { "parametername": "DataFinalViagem", "parametervalue": DataVolta },
          { "parametername": "QtdePassSenior", "parametervalue": QtdePassSenior },
          { "parametername": "QtdePassNaoSenior", "parametervalue": QtdePassNaoSenior },
          { "parametername": "DiscountCoupon", "parametervalue": CupomDesconto },
          { "parametername": "Days", "parametervalue": DiasMultiviagem },
          { "parametername": "ProductTypeCode", "parametervalue": CodigoTipoProduto },
          { "parametername": "SessionID", "parametervalue": SessionID }
        ]
      }
    );
  }

  GetCotizacionDolar(): Observable<ResponseSAS> {
    return this.http.post<ResponseSAS>(
      environment.urlSAS,
      {
        "screenIdentification": environment.getCotizacionDolar
      }
    );

  }

  ConsultaQuantidadePassageiros(): Observable<ResponseSAS> {
    return this.http.post<ResponseSAS>(
      environment.urlSAS,
      {
        "screenIdentification": environment.consultaQuantidadePassageiros
      }
    );
  }

  ConsultaEstados(): Observable<ResponseSAS> {
    return this.http.post<ResponseSAS>(
      environment.urlSAS,
      {
        "screenIdentification": environment.consultaEstados
      }
    );
  }

  ConsultaPaises(): Observable<ResponseSAS> {
    return this.http.post<ResponseSAS>(
      environment.urlSAS,
      {
        "screenIdentification": environment.consultaPaises
      }
    );
  }

  FormasPagamento(
    SessionID: string,
    CodigoProduto: string,
    CodigoTipoProduto: string,
    CodigoMotivoViagem: string,
    DataInicioViagem: string,
    DataFinalViagem: string,
    DiasMultiviagem: string,
    QtdePassSenior: number,
    QtdePassNaoSenior: number,
    CupomDesconto: string,
    CoberturasAdicionais: Array<any>,
  ) {

    return this.http.post<ResponseSAS>(
      environment.urlSAS,
      {
        "userToken": "TOKEN",
        "screenIdentification":
          environment[localStorage.ambiente].formasPagamento,
        "Parameters": [
          { "parametername": "SessionID", "parametervalue": SessionID },
          { "parametername": "CodigoProduto", "parametervalue": CodigoProduto },
          { "parametername": "CodigoTipoProduto", "parametervalue": CodigoTipoProduto },
          { "parametername": "CodigoMotivoViagem", "parametervalue": CodigoMotivoViagem },
          { "parametername": "DataInicioViagem", "parametervalue": DataInicioViagem },
          { "parametername": "DataFinalViagem", "parametervalue": DataFinalViagem },
          { "parametername": "DiasMultiviagem", "parametervalue": DiasMultiviagem },
          { "parametername": "QtdePassSenior", "parametervalue": Number(QtdePassSenior) },
          { "parametername": "CupomDesconto", "parametervalue": CupomDesconto },
          { "parametername": "QtdePassNaoSenior", "parametervalue": Number(QtdePassNaoSenior) },
          { "parametername": "CoberturasAdicionais", "parameterlist": CoberturasAdicionais },
        ]
      }
    );
  }
}
